module.exports = __webpack_public_path__ + "img/5.26830b25.jpg";